
import firebase from 'firebase/app'
// Required for side-effects
import "firebase/firestore"

if (!firebase.apps.length) {
  firebase.initializeApp({
    apiKey: 'AIzaSyCh69bpyLuSxVCjuuCgoWpKPF8CneHr3Rc',
    authDomain: 'realstake-e0ef1.firebaseapp.com',
    projectId: 'realstake-e0ef1'
  });
}

const firestore = firebase.firestore();


export default firestore